var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "End call"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"microphone\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.025 58.1557C54.709 58.1557 58.506 54.472 58.506 49.9279V36.215C58.506 31.6709 54.709 27.9873 50.025 27.9873C45.3411 27.9873 41.544 31.6709 41.544 36.215V49.9279C41.544 54.472 45.3411 58.1557 50.025 58.1557ZM64.16 44.4428H62.7465C61.9655 44.4428 61.333 45.0564 61.333 45.8141V49.9279C61.333 56.3387 55.6357 61.4827 48.8951 60.8451C43.0203 60.2889 38.7171 55.1654 38.7171 49.4394V45.8141C38.7171 45.0564 38.0845 44.4428 37.3036 44.4428H35.8901C35.1091 44.4428 34.4766 45.0564 34.4766 45.8141V49.256C34.4766 56.9386 40.1279 63.7874 47.9048 64.8278V67.7547H42.9575C42.1766 67.7547 41.544 68.3683 41.544 69.126V70.4972C41.544 71.2549 42.1766 71.8685 42.9575 71.8685H57.0925C57.8735 71.8685 58.506 71.2549 58.506 70.4972V69.126C58.506 68.3683 57.8735 67.7547 57.0925 67.7547H52.1453V64.8604C59.7172 63.8525 65.5735 57.5471 65.5735 49.9279V45.8141C65.5735 45.0564 64.941 44.4428 64.16 44.4428Z",
    fill: "#730BDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.1835ad3250c4dc9da86ddf0ac5192c6d.svg";
export { ForwardRef as ReactComponent };